






























































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import AccountDetailField from '@/components/AccountDetailField.vue';
import InfoSection from '@/components/InfoSection.vue';
import Popup from '@/components/Popup.vue';
import Account from '@/models/Account';
import AccountStatus from '@/models/AccountStatus';
import Skill from '@/models/Skill';
import SkillType from '@/models/SkillType';
import Tooltips from '@/constants/Tooltips';

@Component({
  components: {
    AccountDetailField, InfoSection, Popup,
  },
})
export default class AccountDetails extends Vue {
  @Prop({ default: false }) loading!: boolean;

  @State('profile') stateProfile!: any;

  @State('saverbotAccount') stateSaverbotAccount!: Account;

  @Action('disableAccount') actionDisableAccount!: any;

  readonly Tooltips: any = Tooltips;

  formatAccountStatus(status: keyof typeof AccountStatus) {
    return AccountStatus[status];
  }

  formatBalance(balance: string | null) {
    if (balance == null || balance === '') {
      return 'Unknown';
    }

    return this.formatMoney(balance);
  }

  formatMoney(money: string) {
    return `$${money}`;
  }

  formatPercentage(percentage: number) {
    return `${(percentage * 100).toFixed(0)}%`;
  }

  formatSkillSettings(skill: Skill) {
    if (skill.amount) {
      let result = this.formatMoney(skill.amount);

      if (skill.dayOfWeek) {
        result += `, ${skill.dayOfWeek[0] + skill.dayOfWeek.slice(1).toLowerCase()}`;
      }

      return result;
    }

    if (skill.percentage) {
      return this.formatPercentage(skill.percentage);
    }

    return 'Enabled';
  }

  formatSkillType(type: keyof typeof SkillType) {
    return SkillType[type];
  }

  isBalanceLow() {
    return this.stateSaverbotAccount.balance == null
      || +this.stateSaverbotAccount.balance <= +this.stateSaverbotAccount.minBalanceAmount;
  }

  async onConfirmDisable(next: any) {
    await this.actionDisableAccount(this.stateSaverbotAccount.externalId);
    next();
  }
}
